import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Bug, Trash2 } from "lucide-react";

export const ErrorLogsPanel = () => {
  const [logs, setLogs] = useState(null);
  const [open, setOpen] = useState(false);

  const toggle = () => {
    if (open) return setOpen(false);
    setOpen(true);
    api.get("/admin/error-logs").then(({ data }) => setLogs(data)).catch(() => toast.error("Chargement impossible"));
  };

  const clear = async () => {
    if (!window.confirm("Effacer tous les journaux d'erreurs ?")) return;
    await api.delete("/admin/error-logs");
    setLogs([]);
    toast.success("Journaux effacés.");
  };

  return (
    <div className="mt-4">
      <button data-testid="toggle-error-logs-button" onClick={toggle}
        className="inline-flex items-center gap-2 text-sm border border-[#E6E2DD] hover:border-[#C86B5E] text-[#5C5754] hover:text-[#C86B5E] rounded-full px-5 py-2.5 transition-colors">
        <Bug className="w-4 h-4" />
        {open ? "Masquer les erreurs du site" : "Voir les erreurs du site"}
      </button>
      {open && (
        <div data-testid="error-logs-list" className="mt-4 bg-white border border-[#E6E2DD] rounded-2xl p-5 max-h-96 overflow-y-auto">
          {logs === null ? (
            <p className="text-sm text-[#8A8480]">Chargement…</p>
          ) : logs.length === 0 ? (
            <p data-testid="error-logs-empty" className="text-sm text-[#8A8480]">Aucune erreur enregistrée.</p>
          ) : (
            <>
              <div className="flex justify-between items-center mb-3">
                <p className="text-xs text-[#8A8480]">{logs.length} erreur(s) récente(s)</p>
                <button data-testid="clear-error-logs-button" onClick={clear}
                  className="inline-flex items-center gap-1 text-xs text-[#B04A3F] hover:bg-[#B04A3F]/10 rounded-full px-3 py-1.5 transition-colors">
                  <Trash2 className="w-3.5 h-3.5" /> Tout effacer
                </button>
              </div>
              <ul className="divide-y divide-[#F3EFEB]">
                {logs.map((l) => (
                  <li key={l.id} data-testid={`error-log-${l.id}`} className="py-3">
                    <p className="text-sm font-medium text-[#2C2A29] break-words">{l.message}</p>
                    <p className="text-xs text-[#8A8480] break-all">
                      {new Date(l.created_at).toLocaleString("fr-FR")} · {l.source} · {l.user_email || "visiteur"}
                      {l.account_type ? ` (${l.account_type})` : ""}
                    </p>
                    <p className="text-xs text-[#8A8480] break-all">{l.url}</p>
                    {(l.stack || l.component_stack) && (
                      <details className="mt-1">
                        <summary className="text-xs text-[#C86B5E] cursor-pointer">Détails techniques</summary>
                        <pre className="text-[10px] text-[#5C5754] whitespace-pre-wrap mt-1">{l.stack}{"\n"}{l.component_stack}</pre>
                      </details>
                    )}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </div>
  );
};
